// api
import { getPersonalOrders } from '@/api/purchaseAndSaleAPI'
import { getOrderMobile } from '@/api/domain/orders'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
// 其他
import { operateMaxShowLength } from '@/store/dict/config'
import { ORDER_STATE } from '@/store/dict/order.js'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import selectOptionDict from '@/store/dict/selectOptionDict'


export default function config() {
  return {
    formData: {
      list: [
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'carId',
          },
          elConfig: {
            remoteMethod: this.carRemoteMethod,
            filterable: true,
            remote: true,
            clearable: true,
            placeholder: '请输入',
            options: {
              // 下拉数据
              label: 'plateNo',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const carItem = this.m_configData.formData.list.find((item) => item.itemConfig.prop === 'carId')
                this.carConditionList = carItem?.elConfig?.options?.list
              },
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '司机姓名',
            prop: 'customerId',
          },
          elConfig: {
            remoteMethod: this.customerRemoteMethod,
            filterable: true,
            remote: true,
            clearable: true,
            placeholder: '请输入',
            jsxRender: (option) => {
              return <CustomerNameOptionItem data={option} />
            },
            options: {
              // 下拉数据
              label: 'customerName',
              value: 'id',
              list: [],
            },
            events: {
              change: () => {
                const customerItem = this.m_configData.formData.list.find((item) => item.itemConfig.prop === 'customerId')
                this.customerConditionList = customerItem?.elConfig?.options?.list
              },
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '订单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
          elConfig: {
            placeholder: '请输入订单ID',
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '网约钱包支付签约状态',
            prop: 'walletWithholdState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(
                selectOptionDict.walletWithholdState,
                true,
              ),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '支付宝支付签约状态',
            prop: 'personalWithholdState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(
                selectOptionDict.alipayWithholdStateNew,
                true,
              ),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '租赁类别',
            prop: 'rentCategory',
          },
          elConfig: {
            options: {
              label: 'name',
              value: 'code',
              list: [],
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '订单创建时间',
            prop: 'TheOrderStart',
          },
          elConfig: {
            clearable: true,
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '租赁方案名称',
            prop: 'planId',
          },
          elConfig: {
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
      ],
      dealWithSearch: this.dealWithSearch,
      formProps: {
        model: {},
      },
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '订单ID',
            fixed: 'left',
            width: '110',
          },
          render: ({ row }) => {
            if (
              !this.judgePermission('for_rent_sign_contract_rent_order_detail')
            ) {
              return row.id
            }
            return (
              <span
                class="a-hover-link"
                onClick={() =>
                  this.toOrderDetailPage({
                    id: row.id,
                  })
                }
              >
                {row.id}
              </span>
            )
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
            showEllipsisTooltip: true,
            limitEllipsisLine: 1,
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '司机姓名',
            width: 110,
          },
        },
        {
          name: 'customerSafetyTel',
          columnProps: {
            prop: 'customerSafetyTel',
            label: '下单手机号',
            width: 150,
          },
          render: ({ row }) => {
            if (!row.customerSafetyTel) {
              return '--'
            }
            const isRevealed = row._mobileRevealed
            const isLoading = row._mobileLoading
            const displayTel = isRevealed
              ? (row._revealedMobile || row.customerSafetyTel)
              : row.customerSafetyTel
            const hasPermission = this.judgePermission(
              'for_rent_sign_contract_show_order_mobile',
            )
            return (
              <span style="display: inline-flex; align-items: center;">
                <span>{displayTel}</span>
                {hasPermission && !isRevealed && (
                  <el-button
                    type="text"
                    size="mini"
                    loading={isLoading}
                    style="margin-left: 4px; padding: 0;"
                    onClick={async () => {
                      this.$set(row, '_mobileLoading', true)
                      try {
                        const { code, data } = await getOrderMobile({
                          rentOrderId: row.id,
                          customerId: row.customerId,
                        })
                        if (code === 1 && data?.userMobile) {
                          this.$set(row, '_revealedMobile', data.userMobile)
                          this.$set(row, '_mobileRevealed', true)
                        }
                      } finally {
                        this.$set(row, '_mobileLoading', false)
                      }
                    }}
                  >查看</el-button>
                )}
              </span>
            )
          },
        },
        {
          name: 'planName',
          columnProps: {
            prop: 'planName',
            label: '租赁方案',
            width: 150,
          },
        },
        {
          name: 'rentCategoryName',
          columnProps: {
            prop: 'rentCategoryName',
            label: '租赁类别',
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            prop: 'rentAmount',
            label: '每期租金',
            width: '100',
          },
        },
        {
          name: 'deposit',
          columnProps: {
            label: '总押金/已收',
            width: '150',
            align: 'left',
          },
          render: ({ row }) => {
            if (row.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
              return '--'
            }
            return `${row.deposit === null ? '0.00' : row.deposit}` +
            '/' +
            `${row.receivedDeposit}`
          },
        },
        {
          name: 'startDate',
          columnProps: {
            label: '合同周期',
            prop: 'startDate',
            width: '110',
          },
          render: ({ row }) => {
            if (row.startDate) {
              return `${row.startDate} ~ ${row.contractEndDate}`
            }
            return '--'
          },
        },
        {
          name: 'walletWithholdState',
          columnProps: {
            width: '110',
            label: '网约钱包支付',
          },
          render: ({ row }) => {
            // dayAndWeekWalletWithhold 代扣2.0 noOpenReason 有提示文字
            if (row.withholdVersion === 2) {
              return (
                <div>
                  {row.dayAndWeekWalletWithhold?.status !== undefined &&
                    row.dayAndWeekWalletWithhold?.status !== null
                    ? selectOptionDict.walletWithholdState[
                      row.dayAndWeekWalletWithhold?.status
                    ]
                    : '--'}
                  {row.dayAndWeekWalletWithhold?.noOpenReason && (
                    <el-tooltip placement="top-start">
                      <div slot="content">
                        {row.dayAndWeekWalletWithhold.noOpenReason}
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  )}
                </div>
              )
            } else {
              return (
                <div>
                  {row.walletWithholdState.signState !== undefined &&
                    row.walletWithholdState.signState !== null
                    ? selectOptionDict.walletWithholdState[
                      row.walletWithholdState.signState
                    ]
                    : '--'}
                </div>
              )
            }
          },
        },
        {
          name: 'personalWithholdState',
          columnProps: {
            width: '100',
            label: '支付宝支付',
          },
          render: ({ row }) => {
            const { reason } = row.personalWithholdState
            const parseReason = reason ? JSON.parse(reason) : []

            return this.$createElement('div', [
              row.personalWithholdState?.signState !== undefined &&
                row.personalWithholdState?.signState !== null
                ? selectOptionDict.alipayWithholdStateNew[
                  row.personalWithholdState?.signState
                ]
                : '- -',
              // 判断是否有提示文字
              reason
                ? this.$createElement(
                  'el-tooltip',
                  {
                    props: {
                      placement: 'top-start',
                      effect: 'dark',
                    },
                  },
                  [
                    this.$createElement('i', {
                      class: 'el-icon-question',
                    }),
                    this.$createElement(
                      'div',
                      {
                        slot: 'content',
                      },
                      [
                        parseReason.map((item) =>
                          this.$createElement('p', item)),
                      ],
                    ),
                  ],
                )
                : '',
            ])
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '订单创建时间',
            width: '160',
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '订单状态',
            width: '100',
            formatter: (row) => selectOptionDict.leaseOrderState[row.state],
          },
        },
        {
          name: 'source',
          columnProps: {
            label: '下单方式',
            formatter: (row) => selectOptionDict.source[row.source],
          },
        },
        {
          name: 'createUser',
          columnProps: {
            prop: 'createUser',
            width: '110',
            label: '订单创建人',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          type: 'operate',
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            // 待绑车
            //   -- -1500
            // 待履约
            //   --订单待确认 0
            //   --发车待验车 1500
            // 履约中  state === 2500
            // 退车核算
            //   --退车待验车 3500
            //   --订单待核算 4500
            // 已关闭 state === 5500

            const arr = [
              {
                label: '绑车',
                permission:
                  this.judgePermission(
                    'for_rent_sign_contract_rent_order_create',
                  ) && [ORDER_STATE.TO_BIND].includes(Number(row.state)),
                action: () => this.handleToBindCar(row),
              },
              {
                label: '签署合同',
                permission:
                  this.judgePermission(
                    'for_rent_sign_contract_rent_order_confirm',
                  ) && row.state === 0,
                action: () => this.toOrderConfirmPage(row),
              },
              {
                label: '财务收款',
                permission:
                  this.judgePermission(
                    'for_rent_sign_contract_rent_order_finance_detail',
                  ) && row.state === ORDER_STATE.TO_PAY,
                action: () => this.toReceiptandpayment(row),
              },
              {
                label: '资金划扣',
                permission: true,
                action: () => this.toOrderDetailPage({ id: row.id, type: '6' }, '#sign'),
              },
              {
                label: '验车出库',
                permission:
                  this.judgePermission(
                    'for_rent_sign_contract_rent_order_to_out_stock',
                  ) && row.state === ORDER_STATE.TO_CHECK_FOR_SEND,
                action: () => this.outInBankPop(row),
              },
              // 待绑车状态下不展示【退车解约】&【线上代扣】
              {
                label: '退车解约',
                permission:
                  ![ORDER_STATE.TO_BIND].includes(Number(row.state)) &&
                  this.judgePermission(
                    'for_rent_sign_contract_rent_order_cancel_contract',
                  ),
                action: () => this.closeTheCar(row),
              },
              {
                label: '取消',
                permission: [ORDER_STATE.TO_BIND].includes(Number(row.state)),
                action: () => this.handleCancelOrder(row),
              },
            ]

            return arr.filter((i) => i.permission)
          },
        },
      ],
      apiFn: getPersonalOrders,
    },
  }
}
